export default __webpack_public_path__ + "static/media/unauthorized-downgrade.cac6a7c8.svg";